module.exports = __webpack_public_path__ + "img/20.73757ac6.jpg";